// extracted by mini-css-extract-plugin
export default {"JobCard":"JobCard_JobCard__cVY83","jobInfo":"JobCard_jobInfo__LMJT3","jobDetail":"JobCard_jobDetail__V9U2M"};